var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThumbnailSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 11.25C4.0625 7.28045 7.28045 4.0625 11.25 4.0625H20.0161C20.5338 4.0625 20.9536 4.48223 20.9536 5C20.9536 5.51777 20.5338 5.9375 20.0161 5.9375H11.25C8.31599 5.9375 5.9375 8.31599 5.9375 11.25V20.1336C5.9375 20.6514 5.51777 21.0711 5 21.0711C4.48223 21.0711 4.0625 20.6514 4.0625 20.1336V11.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0032 8.49157C18.952 8.03879 14.798 8.03879 10.7468 8.49157C9.59275 8.62056 8.66533 9.52881 8.5293 10.6918C8.04883 14.7999 8.04883 18.95 8.5293 23.0581C8.66533 24.2212 9.59275 25.1294 10.7468 25.2584C14.798 25.7112 18.952 25.7112 23.0032 25.2584C24.1573 25.1294 25.0847 24.2212 25.2207 23.0581C25.7012 18.95 25.7012 14.7999 25.2207 10.6918C25.0847 9.5288 24.1573 8.62056 23.0032 8.49157Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbnailSolid);
export default __webpack_public_path__ + "static/media/icon_thumbnail_solid.4295084a811f79b0db16022a11fa0ea0.svg";
export { ForwardRef as ReactComponent };